<template>
  <div class="form__group--border pt-32 pb-16">
    <fieldset>
      <legend class="form__label pb-8">What types of housekeeping services do you provide?</legend>
      <ul ref="servicesCheckboxList">
        <li v-for="service in serviceTypes" :key="service.value">
          <PoppinsCheckbox
            v-model="services"
            :label-name="service.optionText"
            :aria-label="generateScreenReaderLabel(service.optionText)"
            :value="service.value"
            :required="true"
            :status="formStatuses.services"
            @blur="validate"
          />
        </li>
      </ul>
      <HelperText v-if="!formStatuses.services" class="!-mt-16 mb-16" :text="helperText" :status="helperStatus.Error" />
    </fieldset>
  </div>
</template>

<script lang="ts">
import helperStatus from '@/helpers/status';
import Checkbox from '@/components/checkbox/Checkbox.vue';
import HelperText from '@/components/helper_text/HelperText.vue';
import focusOnElement, { FocusOnElementOptions } from '@/helpers/focusHelper';

export default {
  name: 'HousekeepingServicesCheckbox',
  components: {
    PoppinsCheckbox: Checkbox,
    HelperText,
  },
  data() {
    return {
      helperStatus,
      formStatuses: {
        services: helperStatus.Neutral,
      },
      serviceTypes: [
        {
          value: 'CLEANING',
          optionText: 'Cleaning',
        },
        {
          value: 'SERVICE_ERRANDS',
          optionText: 'Errands',
        },
        {
          value: 'MAINTENANCE',
          optionText: 'Maintenance',
        },
      ],
    };
  },
  computed: {
    services: {
      get() {
        return this.$store.getters.getFormField('services');
      },
      set(newValue) {
        this.formStatuses.services = helperStatus.Neutral;
        return this.$store.dispatch('updateForm', { key: 'services', value: newValue });
      },
    },
    helperText(): string {
      return this.formStatuses.services === helperStatus.Error ? 'At least one type of service is required' : '';
    },
  },
  methods: {
    generateScreenReaderLabel(optionText) {
      return `I will do ${optionText}`;
    },
    validate() {
      if (this.services.length === 0) {
        this.formStatuses.services = helperStatus.Error;
      }

      return this.formStatuses.services;
    },
    focusElement(options: FocusOnElementOptions = {}) {
      const inputElement = (this.$refs.servicesCheckboxList as HTMLElement).querySelector('input');
      if (inputElement) {
        focusOnElement(inputElement, options);
      }
    },
  },
};
</script>
